<template>
  <div class="sales-chart">
    <!-- 플랫폼별 매출 비중 (바 차트) -->
    <div class="chart-container">
      <h3>플랫폼별 매출 비교</h3>
      <bar-chart :chart-data="barChartData" :options="barChartOptions" />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'

// 플랫폼별 매출 바 차트 컴포넌트
const BarChart = {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}

export default {
  name: 'SalesChart',
  components: {
    BarChart
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    rawData: {
      type: Array,
      required: true
    }
  },
  computed: {
    // 플랫폼별 데이터 가공
    platformData() {
      if (!this.rawData) return { labels: [], data: [] }

      const platforms = {
        card: { name: '카드', value: 0 },
        baemin: { name: '배민', value: 0 },
        yogiyo: { name: '요기요', value: 0 },
        coupang: { name: '쿠팡', value: 0 }
      }

      // 데이터 집계
      this.rawData.forEach(payment => {
        if (payment.sales) {
          payment.sales.forEach(sale => {
            if (payment.provider === 'cfa') {
              platforms.card.value += sale.amount
            } else if (platforms[payment.provider]) {
              platforms[payment.provider].value += sale.amount
            }
          })
        }
      })

      // 값이 있는 플랫폼만 필터링
      const filteredPlatforms = Object.values(platforms).filter(p => p.value > 0)


      return {
        labels: filteredPlatforms.map(p => p.name),
        data: filteredPlatforms.map(p => p.value)
      }
    },

    // 바 차트 데이터
    barChartData() {
      const { labels, data } = this.platformData
      return {
        labels,
        datasets: [{
          data,
          backgroundColor: [
            '#FFD700',  // 카드 - 골드 옐로우
            '#F7CAC9',  // 배민 - 파스텔 핑크
            '#98B4D4',  // 요기요 - 파스텔 스카이블루
            '#B5D8CC'   // 쿠팡 - 파스텔 민트
          ],
          borderWidth: 0
        }]
      }
    },

    // 바 차트 옵션
    barChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              borderDash: [2, 2]
            },
            ticks: {
              beginAtZero: true,
              callback: (value) => {
                // 전체 합계 대비 퍼센트로 변환
                const total = this.platformData.data.reduce((a, b) => a + b, 0)
                const percentage = ((value / total) * 100).toFixed(1)
                return percentage + '%'
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const value = data.datasets[0].data[tooltipItem.index]
              const total = data.datasets[0].data.reduce((a, b) => a + b, 0)
              const percentage = ((value / total) * 100).toFixed(1)
              return `${this.$filters.commaFormat(value)}원 (${percentage}%)`
            }
          },
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          titleColor: '#666666',
          bodyColor: '#666666',
          borderColor: '#e0e0e0',
          borderWidth: 1
        }
      }
    }
  },
  created() {
    console.log('SalesChart created with data:', this.data)
  }
}
</script>

<style scoped>
.sales-chart {
  padding: 16px;
}

.chart-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 0px;
  margin-bottom: 16px;
  min-height: 300px;
}

.chart-container h3 {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: 600;
  color: #333333;
}
</style> 